module.exports = function chorusPartial() {
  // custom Hub functions

  let chorusLoaded = false;

  Hubs.Events
    .on('load', () => {
      if (!chorusLoaded) {
        // Call all on load functions here

        chorusLoaded = true;
      }
    })
    .on('itemsLoaded', (itemIds, selectors) => {
      // Call all itemsLoaded events here
    })
    .on('resize', () => {
      // Call all resize events here
    })
    .on('scroll', () => {
      // Call all scroll events here
    })
    .on('ctaActivate', (ctaId) => {
      // Call all ctaActivate events here
    })
    .on('ctaFormSubmitSuccess', (ctaId, mappedData, ctaName) => {
      // Call all ctaFormSubmitSuccess events here
    });
};



// WEBPACK FOOTER //
// ./scriptPartials/hubSpecificFunctions/_chorus.js